import { Avatar, Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import profile_img from "../../../Assets/profile_img.jpg"
import NotificationAllmuiTab from './NotificationAllmuiTab'
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../ReduxStore/actions';
import { adminUrl } from '../../../constants';
import { EventAvailableRounded } from '@mui/icons-material';
import EventsSideBar from '../HomeProfile/EventsSideBar';


const Notification = () => {

    const dispatch = useDispatch();
    const sessionUserId = sessionStorage.getItem("userId");
    const { getUserById } = useSelector(state => state?.getUserById);


    // const { EventGetAll } = useSelector(state => state?.EventGetAll);

    // useEffect(() => {
    //     const fetchData = async () => {
    //         const data1 = {
    //             data: {},
    //             method: "get",
    //             apiName: `getAllEvents`,
    //         };
    //         await dispatch(actions.EVENTGETALL(data1));
    //     };
    //     fetchData();
    // }, [dispatch, sessionUserId]);



    // EventGetAll


    const cygnusaEvents = [
        {
            heading: "Tech Fest: Innovators Ignite",
            date: "05/04/2023 - 30/04/2023",
            content: "Join us for a day of creativity and innovation at the annual Tech Fest, featuring coding competitions, workshops, and expert talks! 🚀"
        },
        {
            heading: "Cultural Carnival: Fusion Fiesta",
            date: "24/05/2023 - 24/05/2023",
            content: "Celebrate diversity with music, dance, and art at our vibrant Cultural Carnival. Unleash your talent and enjoy the magic of unity! 🎭🎶"
        },
        {
            heading: "Sports Extravaganza: Champions Unite",
            date: "01/06/2023 - 01/06/2023",
            content: "Gear up for adrenaline-pumping action at the Sports Extravaganza. Compete, cheer, and make memories on the field! 🏅⚽"
        },
    ]
    const { getUserStatsCount } = useSelector(
        (state) => state?.getUserStatsCount
    );

    useEffect(() => {

        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserStatsCount/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERSTATUSCOUNT(data1));

        }
        fetchData()
    }, [])




    return (

        <Grid container spacing={2} sx={{
            backgroundColor: "rgb(245, 245, 245)",
            minHeight: "100vh",
            pt: 3,
            px: { xs: 3, md: 5 },
            width: "100%",
            pb: 3
        }}>
            <Grid item size={{ md: 3, xs: 12, sm: 12 }} sx={{
                // backgroundColor: "red"
                // display: "flex",
                // flexDirection: "column",
                // // justifyContent:"center",
                // alignItems: "center",
                minHeight: '50vh',
                // backgroundColor: "white",

                borderRadius: "10px",
                textAlign: "center",
                // p: 3

            }}  >

                <Card sx={{ textAlign: "center", mb: 2 }}>
                    <CardContent>
                        <Box sx={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center"
                        }}>


                            <Avatar
                                // src={profile_img}
                                src={`${adminUrl}${getUserById?.data?.profileImage}`}

                                sx={{
                                    // bgcolor: "white",
                                    border: "1px solid white",
                                    height: "200px", width: "80%",
                                    // "& .MuiAvatar-img": {
                                    //     objectFit: ""
                                    // }
                                }}
                            >
                            </Avatar>

                        </Box>

                        <Typography variant="h6">
                            {getUserById?.data?.first_name} {getUserById?.data?.last_name}

                        </Typography>
                        {/* <Typography mt={2} variant='h5'>
                    Professor
                </Typography> */}
                        <Typography mb={3} variant='h5'>
                            {/* National Institute of Fashion Technology */}
                            {getUserById?.data?.course}

                        </Typography>
                        <Divider />
                        <Typography mt={2} sx={{
                            color: "#1976d2",
                            fontSize: "17px",
                            fontWeight: 700
                        }}>
                            {/* 6 */}
                            {getUserStatsCount?.data?.connectionCount || 0}

                        </Typography>
                        <Typography mb={2}>
                            Connections
                        </Typography>
                        <Divider />
                    </CardContent>
                </Card>
            </Grid>



            <Grid item size={{ md: 6, xs: 12, sm: 12 }} sx={{
                // backgroundColor: "white",
                borderRadius: "10px",

            }} >
                <Box sx={{
                    // backgroundColor:"white"
                }}>
                    <NotificationAllmuiTab />
                </Box>

            </Grid>

            <Grid item size={{ md: 3, xs: 12, sm: 12 }} sx={{
                // backgroundColor: "white",
                borderRadius: "10px",
                // p: 3

            }}>
                {/* <Typography sx={{
                    color: "black",
                    fontSize: "22px",
                    fontWeight: 800
                }}>
                    Cygnusa Events
                </Typography>

                {EventGetAll?.data?.map((event, index) => (
                    <Box key={event.event_id} sx={{ mb: 4, p: 2, border: '1px solid #ddd', borderRadius: 2 }}>
                        <Typography sx={{ color: "black", fontSize: "18px", fontWeight: 700, mb: 0.5 }}>
                            {event.event_title}
                        </Typography>

                        <Typography sx={{ color: "gray", fontSize: "14px", mb: 1 }}>
                            {event.campus_name}
                        </Typography>

                        <Typography sx={{ fontSize: "14px", color: "black" }}>
                            From: {event.from_date} &nbsp;&nbsp; To: {event.to_date}
                        </Typography>

                        <Typography variant='body1' sx={{ mt: 1.5, color: "black" }}>
                            {event.requirements}
                        </Typography>

                        {event.attach_files?.length > 0 && (
                            <Box sx={{ mt: 2 }}>
                                <Typography sx={{ fontWeight: 600, mb: 1 }}>Attachments:</Typography>
                                <Grid container spacing={2}>
                                    {event.attach_files.map((file, i) => (
                                        <Grid item key={i}>
                                            {file.fileType === "image" && (
                                                <img
                                                    src={`${adminUrl}${file.fileUrl}`}
                                                    alt={file.fileName}
                                                    style={{ width: 120, borderRadius: 8 }}
                                                />
                                            )}

                                            {file.fileType === "video" && (
                                                <video width="200" controls>
                                                    <source src={`/${file.fileUrl}`} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            )}

                                            {file.fileType === "pdf" && (
                                                <a
                                                    href={`/${file.fileUrl}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: "none", color: "#1976d2" }}
                                                >
                                                    📄 {file.fileName}
                                                </a>
                                            )}
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        )}
                    </Box>
                ))} */}

                <EventsSideBar />
            </Grid>

        </Grid>

    )
}

export default Notification